import React from 'react';
import {Link, LinkProps} from 'react-router-dom';

import Card from 'src/components/Cards/Card';
import Icon from 'shared/components/icon';

import styles from './widget-card.module.scss';

interface Props {
  title: string;
  subtitle: string;
  link: LinkProps['to'];
  icon: string;
}

const WidgetCard = ({title, subtitle, link, icon}: Props) => (
  <Link key={title} to={link} className={styles.container}>
    <Card className={styles.widget}>
      <div className={styles.title}>
        <Icon iconType={icon} className={styles.icon} /> {title}
      </div>
      <div className={styles.subtitle}>
        {subtitle} <Icon iconType="chevron-right" className={styles.arrow} />
      </div>
    </Card>
  </Link>
);

export default WidgetCard;
